import { Component, OnInit } from '@angular/core';
import { AppConfig } from '../../app-config';

@Component({
  selector: 'app-confidentiality-agreement',
  templateUrl: './confidentiality-agreement.component.html'
})
export class ConfidentialityAgreementComponent implements OnInit {

  constructor(private config: AppConfig) { }
  IsPortal = this.config.IsPortal;
  documentPath;

  ngOnInit() {
    if (!this.IsPortal)
      this.documentPath = this.config.CADocumentURL
    else
      this.documentPath = this.config.CADocumentURLPortal

  }
}
